<svg viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M22.504 14.568C22.504 16.616 20.968 18.408 18.408 18.408C15.08 18.408 13.288 15.592 13.288 12.264C13.288 7.4 16.616 3.816 21.224 1L23.528 3.048C21.224 4.584 19.176 6.12 19.176 8.168C19.176 10.728 22.504 11.24 22.504 14.568ZM10.216 14.568C10.216 16.616 8.68 18.408 6.12 18.408C2.792 18.408 1 15.592 1 12.264C1 7.4 4.328 3.816 8.936 1L11.24 3.048C8.936 4.584 6.888 6.12 6.888 8.168C6.888 10.728 10.216 11.24 10.216 14.568Z"
		fill="#ED6D50"
	/>
</svg>
